/* unplugin-vue-components disabled */import { render } from "./add-output.vue?vue&type=template&id=66646bab&scoped=true"
import script from "./add-output.vue?vue&type=script&lang=js"
export * from "./add-output.vue?vue&type=script&lang=js"

import "./add-output.vue?vue&type=style&index=0&id=66646bab&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66646bab"],['__file',"src/pages/settings/admin/test-agents/add-output.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66646bab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66646bab', __exports__)) {
    api.reload('66646bab', __exports__)
  }
  
  module.hot.accept("./add-output.vue?vue&type=template&id=66646bab&scoped=true", () => {
    api.rerender('66646bab', render)
  })

}


export default __exports__